// eslint-disable-next-line import/prefer-default-export
export const MIN_STRUCTURE_LABEL_SIZE = 140;
